import {
    FETCH_RESUME_OPTIONS_INIT,
    FETCH_RESUME_OPTIONS_SUCCESS,
    FETCH_RESUME_OPTIONS_FAILURE,
} from '../actions/ResumeOptionActions';

const initialState = {
    data: null,
    loading: true,
    error: false,
};

export default function ResumeOptionsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_RESUME_OPTIONS_INIT:
            return {...state, loading: true, error: false};

        case FETCH_RESUME_OPTIONS_SUCCESS: {
            const data = {...action.payload};
            if (Array.isArray(data.modalServices)) data.modalServices = data.modalServices.map(String);
            if (Array.isArray(data.modalFeature)) data.modalFeature = data.modalFeature.map(String);
            return {data, loading: false, error: false};
        }

        case FETCH_RESUME_OPTIONS_FAILURE:
            return {...state, loading: false, error: true};
    }

    return state;
}
